'use strict'

import BaseService from './baseService'
import { Constants } from '../utils/constants'

const serviceURL = `/api/${Constants.BASE_API_VERSION}`

export default class CashInLieuRequestService extends BaseService {
  async getRequestsPendingUserAction (employeeId) {
    var result = await this.sendRequest('GET', `${serviceURL}/cashInLieuRequests/Pending/${employeeId}`)
    return result.data
  }

  async getRequests(employeeId, year) {
    var result = await this.sendRequest('GET', `${serviceURL}/cashInLieuRequests/${employeeId}/${year}`)
    return result.data
  }

  async schedule(request) {
    const result = await this.sendRequest('POST', `${serviceURL}/${request.requestType}Requests`, request)
    return result.data
  }
}
